import { Component, Input } from '@angular/core';
import { WorkSchedule } from '@app/models/time-off-v3/works-schedule.model';
import { DaysKeys } from '@time-off-v3/meta/time-off-meta';

@Component({
    selector: 'app-overall-settings-card',
    templateUrl: './overall-settings-card.template.html',
    styleUrls: ['./overall-settings-card.style.scss'],
})
export class OverallSettingsCardComponent {
    @Input() workSchedule: WorkSchedule = new WorkSchedule();

    days = DaysKeys;
}
